export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7786.63a4ff9f.jpg";